export default __webpack_public_path__ + "static/media/LCA__TAM_0280_tn.94e8f762.jpg";